import types from './actionsTypes';

const initialState = {
  isLoggedIn: false,
  isProgressLoader: true,
  loggedInUsername: '',
  loggedInUserId: '',
  firstName: '',
  lastName: ''
};

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_LOGIN:
      return {
        ...state,
        isLoggedIn: true,
        loggedInUsername: action.payload.username,
        loggedInUserId: action.payload.userId,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName
      };
    case types.TOGGLE_PAGE_LOADER:
      return {
        ...state,
        isProgressLoader: !state.isProgressLoader,
      };

    case types.RESET_LOGIN:
      return {
        ...state,
        isLoggedIn: false,
        isProgressLoader: false,
      };
    default:
      return state;
  }
}
